import dropdown from "./dropdown";

const dealersTabs = (dropdownClass = '.js-dealers-dropdown', tabs = '.js-dealers-tab') => {
    dropdown(dropdownClass, (ev) => {
        let attr = $(ev.currentTarget).data('dealer');

        $(tabs).each((i, elem) => {
            let currentAttr = $(elem).data('tab-dealer');
            if (attr === currentAttr) {
                $(elem).addClass('active');
            } else {
                $(elem).removeClass('active');
            }
        });
    });
};

export default dealersTabs;